import axios from "axios";
import { ElMessage } from 'element-plus'
import * as Utils from './utils'

const ENV = (window.location.href.indexOf('qa-') != -1 || window.location.href.indexOf('local') != -1) ? 'test' : 'production'
console.log('ENV--', ENV)
// const ENV = 'production'

export const loginURL = ENV === 'test' ? 'https://qa-passport.geekyum.com/login' : 'https://passport.geekyum.com/login';
export const logoutURL = ENV === 'test' ? 'https://qa-gateway.geekyum.com/api/10020/sso/logout' : 'https://gateway.geekyum.com/api/10020/sso/logout';
export const baseURL = ENV === 'test' ? 'https://qa-gateway.geekyum.com/api' : 'https://gateway.geekyum.com/api';
export const uploadURL = `${baseURL}/10070/base/upload/upload_file?content=${encodeURIComponent(JSON.stringify({"header":{},"model":{"fileTypeId":5}}))}`;

export const request = (options = {}) => {
  const { url, data, header = {}, method } = options;

  const instance = axios.create({
    baseURL,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    timeout: 8000
  });
  instance.interceptors.request.use(config => {
    config.headers['Access-Control-Allow-Origin'] = '*';

    const token = Utils.user.getToken();
    if (token) {
      config.headers['Authorization'] = token;
    }

    return config
  });
  instance.interceptors.response.use(
    (res) => {
      if (res?.data?.status === 200) {
        return Promise.resolve(res.data)
      } else {
        if(res?.data?.msg) {
          ElMessage.error(res?.data?.msg)
          if(res?.data?.code == 410) {
            setTimeout(() => {
              Utils.user.logout();
              window.location.href = `${loginURL}?redirect=${window.location.href}`;
            }, 1000)
            return;
          }
        }
        return Promise.resolve(res.data)
      }
    },
    (err) => {
      if (err?.response?.status === 401) {
        console.error('401')
        //未登录或登录过期
        Utils.user.logout();
        window.location.href = `${loginURL}?redirect=${window.location.href}`;
        return err;
      }

      console.error('err', err.message);
      return Promise.reject(err);
    }
  );

  return instance({ 
    url, 
    data: { 
      header, 
      model: data
      // ...data 
    },
    method 
  });
};

export const post = (options = {}, hideErr = false) => {
  return request({
    ...options,
    method: 'POST'
  }).catch(err => {
    console.log('err', err)
    if(!hideErr) {
      Utils.toast(err);
      return false;
    }
    return { error: err }
  });
};

export const del = (options = {}) => {
  return request({
    ...options,
    method: 'DELETE'
  });
};


export const get = (options = {}) => {
  return request({
    ...options,
    method: 'GET'
  });
};
